import { render, staticRenderFns } from "./StepSix.vue?vue&type=template&id=537e6efb&scoped=true"
import script from "./StepSix.vue?vue&type=script&lang=ts"
export * from "./StepSix.vue?vue&type=script&lang=ts"
import style0 from "./StepSix.vue?vue&type=style&index=0&id=537e6efb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537e6efb",
  null
  
)

export default component.exports